<template lang="html">

<el-row :gutter="10">

    <el-alert
      title="设置【公众号二维码】后便于用户通过汽车网关注该公众号"
      type="success">
    </el-alert>

    <el-col class="basic-margin">
      <el-upload
        class="avatar-uploader"
        :action="baseUrl+'channel/settingQRCode.action'"
        :show-file-list="false"
        :headers="headers"
        name="QR"
        :data="{channelId:channelId}"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload">
        <img v-if="QRImageUrl" :src="imageUrl+QRImageUrl" class="avatar">
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <div style="font-size:10px;">
        点击图片 添加 / 修改，建议尺寸150*150
      </div>
    </el-col>

    <el-col class="basic-margin" :span="12">
      <h4><b>使用场景：</b></h4>
      <el-col :span="24">
        <img style="width:100%" src="static/gongzhonghao.png"></img>
      </el-col>
    </el-col>
</el-row>

</template>

<script>

import Config from '@/framework/configs/Config'
import channelModel from '@/framework/models/channelModel'
import BasicPager from '@/mixins/BasicPager'
export default {
  name: 'wechat-public-number',
  extends: BasicPager,
  data: function () {
    return {
      baseUrl: Config.baseUrl,
      imageUrl: Config.imageUrl,
      QRImageUrl: null,
      channelId: null,
      headers: {
        loginPath: null,
        token: null,
        loginAccountId: null
      }

    }
  },
  created: function () {
    // 获取登录信息
    let loginInfo = this.loginInfo
    if (!loginInfo) {
      return
    }

    // 校验是否是渠道只有渠道才能设置公众号
    if (loginInfo.loginPath != 'channel') {
      return
    }

    this.headers.token = loginInfo.token
    this.headers.loginPath = loginInfo.loginPath
    this.headers.loginAccountId = loginInfo.id
    this.channelId = loginInfo.id

    this.selectQRCode()
  },
  methods: {
    beforeAvatarUpload: function (file) {
      // 获取登录信息
      let loginInfo = this.loginInfo
      if (!loginInfo) {
        this.$message({
          message: '登录信息已失效！',
          type: 'warning'
        })
        return
      }

      // 校验是否是渠道只有渠道才能设置公众号
      if (loginInfo.loginPath != 'channel') {
        this.$message({
          message: '只有渠道才能上传公众号，你不是渠道哦！',
          type: 'warning'
        })
      }
    },
    handleAvatarSuccess: function (response, file, fileList) {
      this.QRImageUrl = response.datas
      this.$message({
        message: '设置成功！',
        type: 'success'
      })
    },
    selectQRCode: function () {
      // 获取渠道id
      let channelId = this.loginInfo.id

      // 请求公众号二维码
      let _this = this
      let params = {
        channelId: channelId
      }

      let listener = {
        success: function (dataInfo) {
          _this.QRImageUrl = dataInfo.datas
        }
      }

      channelModel.selectQRCode(_this, params, listener)
    }
  }
}

</script>
